export const shopContent = {
  hero: {
    title: "Sacred Soil Alphabet",
    quote: "Our art is an intentional tool for spelling messages that spread the regenerative frequency",
    description: "First Edition \u2022 Limited Collection \u2022 26 Letters + Numbers",
    sacredGeometry: "Our letters are designed with sacred geometry correlating to the numerical order of the alphabet"
  },
  framework: {
    steps: [
      { title: "Participate", description: "Choose your letter" },
      { title: "Communicate", description: "Display and share the message" },
      { title: "Regenerate", description: "Your purchase funds soil restoration" }
    ]
  },
  explanation: {
    title: "More Than Art. A Voice in the Movement.",
    text: "Every piece of ERB alphabet art is a stake in a growing movement to regenerate Earth\u2019s soil. When you collect, you:",
    receive: [
      { label: "Join the founding community", desc: "Be part of the movement from day one" },
      { label: "Own scarce first-edition art", desc: "Limited supply, lasting value" },
      { label: "Fund soil regeneration", desc: "Proceeds support the mission" },
      { label: "Help build certification", desc: "Your purchase grows our ability to certify regenerative businesses" }
    ],
    quote: "Spell what you will on your wall and in your wallet"
  },
  products: {
    title: "Products",
    items: [
      {
        type: "DIGITAL COLLECTIBLE \u2014 NFT",
        price: "0.23 SOL",
        features: ["Art on Solana blockchain", "First edition scarcity", "Tradeable and collectible", "Movement membership included"],
        action: "COLLECT NFT"
      },
      {
        type: "PHYSICAL ART \u2014 Laser-Cut Wood",
        price: "$100",
        features: ["Handcrafted wooden piece", "Display in your home or office", "Tangible symbol of your commitment", "Movement membership included"],
        action: "ORDER PHYSICAL"
      }
    ]
  },
  collection: {
    title: "Choose Your Letter",
    subtitle: "Spell your name, business or make a statement"
  },
  assets: [
    ...Array.from({ length: 26 }, (_, i) => ({
      type: 'Letter',
      char: String.fromCharCode(65 + i),
      name: `Frequency: ${String.fromCharCode(65 + i)}`,
      price: '0.23 SOL | $100',
      img: `/letters/erb-${String.fromCharCode(97 + i)}-1.jpg`,
      marketplaceUrl: 'https://exchange.art/gallery/sacred-soil-alphabet',
    })),
    ...Array.from({ length: 10 }, (_, i) => ({
      type: 'Number',
      char: i.toString(),
      name: `Frequency: ${i}`,
      price: '0.23 SOL | $100',
      img: `/letters/erb-${i}-1.jpg`,
      marketplaceUrl: 'https://exchange.art/gallery/sacred-soil-alphabet',
    }))
  ],
  closing: {
    title: "Planting the Seed",
    text: "This is the first edition. The beginning. The founding moment. Every letter you collect is a seed planted in the movement. As the community grows, so does the voice. As the voice grows, so does the soil.",
    quote: "Your ownership of ERB art is an autograph giving earth the right to eat a digestible form of human creativity. Represented in your wallet where it matters most.",
    cta: "CONTACT US"
  }
};
